import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

interface ClientLog {
  _id: string,
  incidentCategory: string,
  summary: string,
  description: string,
  reportedOn: string,
  incidentDate: string,
  incidentTime: string,
  intensityLevel: string,
  clientID: string,
  county: string,             
  hotlineCalled: boolean,      
  lawEnforcementInvolved: boolean, 
  openCourtCase: boolean,      
  eventDescription: string,    
  personsInvolved: string,     
}
  
  export const getIncidentReport = createAsyncThunk(
    '/incident-reports/get',
    async ({ page, pageSize, sortBy, sortDir, searchTerm, clientID }: { page: number, pageSize: number, sortBy: string, sortDir: string, searchTerm: string, clientID: string }) => {
      try {
        const response = await axios.get(`/incident-reports/get?page=${page}&pageSize=${pageSize}&sortBy=${sortBy}&sortDir=${sortDir}&searchTerm=${searchTerm}&clientID=${clientID}`);
        return {
          data: response.data.data,
          currentPage: response.data.currentPage,
          totalPages: response.data.totalPages,
          totalCounts: response.data.totalCounts
        };
      } catch (err) {
        console.log(err);
        return err;
      }
    }
  );

export const getSearchIncidentReport = createAsyncThunk(
  'incident-report/search',
  async (searchTerm) => {
    try {
      const response = await axios.get(`incident-report/search?searchTerm=${searchTerm}`)
      return {
        data: response.data  
      }
    } catch (err) {
      console.log(err);
      return err;
    }
  }
);

export const getOneIncidentReport = createAsyncThunk(
  '/incident-reports/getOne/',
  async (id: string | undefined) => {
    try {
      const response = await axios.get('/incident-reports/getOne/' + id)
      return {
        data: response.data
      }
    } catch (err) {
      console.log(err);
      return err;
    }
  }
);

export const addIncidentReport = createAsyncThunk(
  'incident-reports/create',
  async (data: ClientLog) => {
    try {
      const response = await axios.post('incident-reports/create', data)
      return response.data
    } catch (err) {
      console.log(err);
      return err;
    }
  }
);

export const deleteIncidentReport = createAsyncThunk(
  'incident-reports/delete/',
  async (data: string) => {
    try {
      const response = await axios.delete('incident-reports/delete/' + data)
      return response.data
    } catch (err) {
      console.log(err);
      return err;
    }
  }
);

export const updateIncidentReport = createAsyncThunk(
  'incident-reports/update',
  async (data: ClientLog) => {
    try {
      console.log(data)
      const response = await axios.put('/incident-reports/update', data)
      console.log(response.data)
      return response.data
    } catch (err) {
      console.log(err);
      return err;
    }
  }
);
